export default {
  setInitialState({commit, state}) {
    const poster = {
      content: '',
      initial_content: undefined,
      theme_id: undefined,
      template_id: undefined,

      sales_unit_id: undefined,
      product_id: undefined,
      department_id: undefined,

      fetchedPoster: undefined,

      promotion_product_id: undefined,
      promotion_unit_id: undefined,
      promotion_unit2_id: undefined,
      payment_types: [],
      proportional_measures: [
          'Quilograma',
          'Litro',
          'Centímetro',
      ],
      selected_type: undefined,
      insertExpirationDates: false,
      insertProportionalValueInline: false,
      insertProductProportionalValueInline: false,
      insertProductExpirationDates: false,
      insertProductOlder: false,

      fields: {
        cet_py: 0,
        cet: 0,
        departament: '',
        with_down_payment: false,
        integration_code: '',
        discount: 0,
        discount_bundle: 0,
        has_interest: undefined,
        legal_informations: '',
        main_description: '',
        main_description2: '',
        main_description3: '',
        minor_description: '',
        minor_description2: '',
        minor_description3: '',
        simple_description: '',
        simple_description2: '',
        simple_description3: '',
        simple_description4: '',
        simple_description5: '',
        reoperated_product: '',
        product_other_sizes: '',
        product_other_colors: '',
        product_comments: '',
        product_evaluation: '',
        product_material: '',
        product_depth: '',
        product_height: '',
        product_width: '',
        brand: '',
        retail_packaging: '',
        wholesale_packing: '',
        big_packing: '',
        validation: '',
        retail_taxation: '',
        wholesale_taxation: '',
        big_taxation: '',
        light_taxation: '',
        retail_media: '',
        wholesale_media: '',
        big_media: '',
        light_media: '',
        big_price: '',
        light_price: '',
        light_quantity: '',
        free_text: '',
        free_text2: '',
        free_text3: '',
        parcel_paid: 0,
        parceled_interest: 0,
        parceled_interest_2: 0,
        parcel: 0,
        parcel_separated_2: 0,
        exclusive_parcel: 0,
        parceled: 0,
        payment_type: '',
        condition: '',
        product_code: '',
        promotion_description: '',
        promotion_main_description: '',
        promotion_minor_description: '',
        promotion_product: '',
        promotion_unit: '',
        promotion_unit2: '',
        promotional_product_value: 0,
        quantity: 0,
        quantity2: 0,
        quantity3: 0,
        rates_info: '',
        sales_unit: '',
        sales_unit2: '',
        sales_unit3: '',
        sales_unit_wholesale: '',
        spare: 0,
        spared_percent: 0,
        total_term: 0,
        total_term_2: 0,
        valid_from: undefined,
        valid_until: undefined,
        validate: undefined,
        free_value: 0,
        value_cash: 0,
        value_cash2: 0,
        value_cash3: 0,
        value_bundle: 0,
        value_divided: 0,
        value_old: 0,
        reduced_value: 0,
        old_price: 0,
        value_old2: 0,
        value_old3: 0,
        value_plot_interest: 0,
        value_plot_interest_2: 0,
        value_plot: 0,
        value_remaining: 0,
        value_retail: 0,
        value_sum: 0,
        value_total_wholesale: 0,
        value_wholesale: 0,
        unitary_value: 0,
        cashback_value: 0,
        cashback_value_2: 0,
        value_in_cash: 0,
        exclusive_value_in_cash: 0,
        exclusive_value_cash: 0,
        total_value: 0,
        qrcode: '',
        custom_qr_code: '',
        insert_qrcode: false,
        insert_custom_qrcode: false,
        barcode: '',
        insert_barcode: false,
        inputs: 0,
        value_wholeretail: 0,
        value_wholeretail_2: 0,
        value_wholeretail_3: 0,
        value_wholeretail_4: 0,
        value_wholeretail_5: 0,
        proportional_value: 0,
        quantity4: 0,
        quantity5: 0,
        unit_proportional: '',
        from_wholesale: '',
        from_large: '',
        exclusive_parcel_2: 0,
        exclusive_value_in_cash_2: 0,
        exclusive_value_cash_2: 0,
        exclusive_value_plot_2: 0,
        ibm_code: '',
        product_weight: '',
        highlight_1: '',
        highlight_2: '',
        highlight_3: '',
        highlight_4: '',
        highlight_5: '',
        highlight_6: '',
        value_wholesale_card: 0,
        value_cash_tag: 0,
        insert_value_cash_tag: false,
        proportional_measure: '',
        proportional_quantity: 0,
        product_proportional_value: 0,
        quantity_fractional: 0,
        base_value: 0,
        base_total_value: 0,
        base_parcel_quantity: 0,
        base_parcel_value: 0,
        derived_code: 0,
        warranty: '0',
        assembly: '0',
        about_product: '',
        supported_weight: '',
        discount_fastshop: '',
        offer_information: '',
        insert_offer_information: false,
        optional_free_text: '',
        insert_optional_free_text: false,
        value_plot_separated_2: 0,
        percentage_app: 0,
        price_app: 0,
        limit_app: '',
        percentage_card: '',
        price_card: 0,
        limit_card: '',
        parcel_number_card: 0,
        parcel_price_card: 0,
        minimum_app: '',
      }
    };

    const product = {
      id: undefined,
      code: '',
      barcode: '',
      custom_qr_code: '',
      integration_code: '',
      main_description: '',
      minor_description: '',
      ibm_code: '',
      product_weight: '',
      highlight_1: '',
      highlight_2: '',
      highlight_3: '',
      highlight_4: '',
      highlight_5: '',
      highlight_6: '',
    };
    commit('poster/SET_PRODUCT', product);
    commit('SET_POSTER', poster);
    commit('SET_FETCHED_POSTER', poster);
    commit('selector/SET_TEMPLATE', undefined);
    commit('product/SET_DEPARTMENTS', []);
    commit('product/SET_PRODUCTS', []);
    commit('product/SET_UNITS', []);
  },

  clearFields({commit, state}) {
    let fields = {
      cet_py: 0,
      cet: 0,
      departament: '',
      integration_code: '',
      discount: 0,
      discount_bundle: 0,
      has_interest: undefined,
      with_down_payment: false,
      legal_informations: '',
      main_description: '',
      main_description2: '',
      main_description3: '',
      minor_description: '',
      minor_description2: '',
      minor_description3: '',
      simple_description: '',
      simple_description2: '',
      simple_description3: '',
      simple_description4: '',
      simple_description5: '',
      reoperated_product: '',
      product_other_sizes: '',
      product_other_colors: '',
      product_comments: '',
      product_evaluation: '',
      product_material: '',
      product_depth: '',
      product_height: '',
      product_width: '',
      brand: '',
      retail_packaging: '',
      wholesale_packing: '',
      big_packing: '',
      validation: '',
      retail_taxation: '',
      wholesale_taxation: '',
      big_taxation: '',
      light_taxation: '',
      retail_media: '',
      wholesale_media: '',
      big_media: '',
      light_media: '',
      big_price: '',
      light_price: '',
      light_quantity: '',
      free_text: '',
      free_text2: '',
      free_text3: '',
      parcel_paid: 0,
      parceled_interest: 0,
      parceled_interest_2: 0,
      parcel: 0,
      parcel_separated_2: 0,
      exclusive_parcel: 0,
      parceled: 0,
      payment_type: '',
      product_code: '',
      promotion_description: '',
      promotion_main_description: '',
      promotion_minor_description: '',
      promotion_product: '',
      promotion_unit: '',
      promotion_unit2: '',
      promotional_product_value: 0,
      quantity: 0,
      quantity2: 0,
      quantity3: 0,
      rates_info: '',
      sales_unit: '',
      sales_unit2: '',
      sales_unit3: '',
      condition: '',
      sales_unit_wholesale: '',
      spare: 0,
      spared_percent: 0,
      total_term: 0,
      total_term_2: 0,
      valid_from: undefined,
      valid_until: undefined,
      validate: undefined,
      free_value: 0,
      value_cash: 0,
      value_cash2: 0,
      value_cash3: 0,
      value_bundle: 0,
      value_divided: 0,
      value_old: 0,
      reduced_value: 0,
      value_old2: 0,
      value_old3: 0,
      value_plot_interest: 0,
      value_plot_interest_2: 0,
      value_plot: 0,
      value_plot_separated: 0,
      value_plot_separated_2: 0,
      exclusive_value_plot: 0,
      value_remaining: 0,
      value_retail: 0,
      value_sum: 0,
      value_total_wholesale: 0,
      value_wholesale: 0,
      unitary_value: 0,
      cashback_value: 0,
      cashback_value_2: 0,
      value_in_cash: 0,
      exclusive_value_in_cash: 0,
      exclusive_value_cash: 0,
      total_value: 0,
      qr_code: '',
      custom_qr_code: '',
      insert_qrcode: false,
      insert_custom_qrcode: false,
      bar_code: '',
      insert_barcode: false,
      image: '',
      inputs: 0,
      value_wholeretail: 0,
      value_wholeretail_2: 0,
      value_wholeretail_3: 0,
      value_wholeretail_4: 0,
      value_wholeretail_5: 0,
      proportional_value: 0,
      quantity4: 0,
      quantity5: 0,
      unit_proportional: '',
      exclusive_parcel_2: 0,
      exclusive_value_in_cash_2: 0,
      exclusive_value_cash_2: 0,
      exclusive_value_plot_2: 0,
      ibm_code: '',
      product_weight: '',
      highlight_1: '',
      highlight_2: '',
      highlight_3: '',
      highlight_4: '',
      highlight_5: '',
      highlight_6: '',
      value_wholesale_card: 0,
      value_cash_tag: 0,
      insert_value_cash_tag: false,
      proportional_measure: '',
      proportional_quantity: 0,
      product_proportional_value: 0,
      quantity_fractional: 0,
      base_value: 0,
      base_total_value: 0,
      base_parcel_quantity: 0,
      base_parcel_value: 0,
      derived_code: 0,
      warranty: '0',
      assembly: '0',
      about_product: '',
      supported_weight: '',
      discount_fastshop: '',
      offer_information: '',
      insert_offer_information: false,
      optional_free_text: '',
      insert_optional_free_text: false,
      percentage_app: 0,
      price_app: 0,
      limit_app: '',
      percentage_card: '',
      price_card: 0,
      limit_card: '',
      parcel_number_card: 0,
      parcel_price_card: 0,
      minimum_app: '',
    };
    commit('SET_FIELDS', fields);
    const product = {
      id: undefined,
      code: '',
      bar_code: '',
      qr_code: '',
      custom_qr_code: '',
      integration_code: '',
      main_description: '',
      minor_description: '',
      ibm_code: '',
      product_weight: '',
      highlight_1: '',
      highlight_2: '',
      highlight_3: '',
      highlight_4: '',
      highlight_5: '',
      highlight_6: '',
    };
    commit('poster/SET_PRODUCT', product);
  },


}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/actions.js